import type { FunctionComponent, RefObject } from 'react'
import styled from 'styled-components'

const StyledInput = styled.input`
  appearance: none;
  font-size: 1rem;
  border: 1px solid rgb(118, 118, 118);
  border-radius: 0;
  box-sizing: border-box;
  line-height: 1.125rem;
  padding: 0.5rem;
  width: 100%;
  height: 44px;
`

const Input: FunctionComponent<{
  id?: string
  type?: string
  required?: boolean
  value?: string | number | readonly string[]
  autoComplete?: string
  onInvalid?: () => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  inputRef?: RefObject<HTMLInputElement | null>
  name?: string
}> = ({
  id,
  type,
  required,
  value,
  autoComplete,
  onInvalid,
  onChange,
  placeholder,
  inputRef,
  name,
  ...otherProps
}) => (
  <StyledInput
    id={id}
    type={type}
    required={required}
    value={value}
    autoComplete={autoComplete}
    onInvalid={onInvalid}
    onChange={onChange}
    placeholder={placeholder}
    name={name}
    ref={inputRef}
    {...otherProps}
  />
)

export default Input
